/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { usePageTitles } from '../hooks/use-page-title';
import PageLayout from '../components/layout/PageLayout';

const withLayout = (Component) => (props) => {
    const pageTitle = usePageTitles();
    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            <PageLayout>
                <Component {...props} />
            </PageLayout>
        </>
    );
};

export default withLayout;
